import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import './QuoteReveal.css';

const QUOTE = "Roofing is more than a structure—it's your home's foundation. We empower homeowners with quality craftsmanship, clear pricing, and durable solutions for lasting security and value.";

function QuoteReveal() {
  const containerRef = useRef(null);
  
  // Track scroll progress within the container
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start 0.9", "end 0.2"]
  });

  const words = QUOTE.split(" ");

  return (
    <section className="quote-reveal" ref={containerRef}>
      <div className="container">
        <div className="quote-reveal__text-wrapper">
          <p className="quote-reveal__paragraph">
            {words.map((word, i) => {
              const start = i / words.length;
              const end = start + (1 / words.length);
              return <Word key={i} progress={scrollYProgress} range={[start, end]}>{word}</Word>;
            })}
          </p>
        </div>
      </div>
    </section>
  );
}

const Word = ({ children, progress, range }) => {
  // Map scroll progress to word opacity
  const opacity = useTransform(progress, range, [0.15, 1]);
  
  return (
    <span className="quote-reveal__word-container">
      <motion.span style={{ opacity }} className="quote-reveal__word">
        {children}
      </motion.span>
    </span>
  );
};

export default QuoteReveal;
